let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // Each subscriber is invoked in isolation: a synchronous throw from one
    // (e.g. a bug in a single feature's cart:update handler) must not stop
    // Array.map from reaching the rest, which would otherwise silently skip
    // every subscriber registered after it — including core cart UI updates.
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data)).catch((error) => {
          console.error('pubsub: subscriber for "' + eventName + '" failed', error);
        });
      } catch (error) {
        console.error('pubsub: subscriber for "' + eventName + '" failed', error);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
